// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInvitationData, AcceptInvitationErrors, AcceptInvitationResponses, ApprovePaymentData, ApprovePaymentErrors, ApprovePaymentResponses, ArchiveCounterpartyData, ArchiveCounterpartyErrors, ArchiveCounterpartyResponses, CancelPaymentData, CancelPaymentErrors, CancelPaymentResponses, CreateCounterpartyData, CreateCounterpartyErrors, CreateCounterpartyResponses, CreateInvitationData, CreateInvitationErrors, CreateInvitationResponses, CreateOrgData, CreateOrgErrors, CreateOrgResponses, CreatePaymentData, CreatePaymentErrors, CreatePaymentResponses, GetAccountStatementData, GetAccountStatementErrors, GetAccountStatementResponses, GetApprovalPolicyData, GetApprovalPolicyErrors, GetApprovalPolicyResponses, GetCounterpartyData, GetCounterpartyErrors, GetCounterpartyResponses, GetMeData, GetMeErrors, GetMeResponses, GetOnboardingData, GetOnboardingErrors, GetOnboardingResponses, GetOrgData, GetOrgErrors, GetOrgResponses, GetPaymentData, GetPaymentErrors, GetPaymentLimitsData, GetPaymentLimitsErrors, GetPaymentLimitsResponses, GetPaymentResponses, ListAccountsData, ListAccountsErrors, ListAccountsResponses, ListActivityData, ListActivityErrors, ListActivityResponses, ListCounterpartiesData, ListCounterpartiesErrors, ListCounterpartiesResponses, ListFundingInstrumentsData, ListFundingInstrumentsErrors, ListFundingInstrumentsResponses, ListInvitationsData, ListInvitationsErrors, ListInvitationsResponses, ListMembersData, ListMembersErrors, ListMembersResponses, ListPaymentsData, ListPaymentsErrors, ListPaymentsResponses, ListRolesData, ListRolesErrors, ListRolesResponses, PutApprovalPolicyData, PutApprovalPolicyErrors, PutApprovalPolicyResponses, QuotePaymentData, QuotePaymentErrors, QuotePaymentResponses, RejectPaymentData, RejectPaymentErrors, RejectPaymentResponses, RemoveMemberData, RemoveMemberErrors, RemoveMemberResponses, RevokeInvitationData, RevokeInvitationErrors, RevokeInvitationResponses, SaveOnboardingData, SaveOnboardingErrors, SaveOnboardingResponses, SimulateDepositData, SimulateDepositErrors, SimulateDepositResponses, SubmitOnboardingData, SubmitOnboardingDocumentsData, SubmitOnboardingDocumentsErrors, SubmitOnboardingDocumentsResponses, SubmitOnboardingErrors, SubmitOnboardingResponses, UpdateMemberData, UpdateMemberErrors, UpdateMemberResponses, UpdateOrgData, UpdateOrgErrors, UpdateOrgResponses, UploadOnboardingDocumentData, UploadOnboardingDocumentErrors, UploadOnboardingDocumentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/me',
    ...options
});

export const createOrg = <ThrowOnError extends boolean = false>(options: Options<CreateOrgData, ThrowOnError>): RequestResult<CreateOrgResponses, CreateOrgErrors, ThrowOnError> => (options.client ?? client).post<CreateOrgResponses, CreateOrgErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getOrg = <ThrowOnError extends boolean = false>(options: Options<GetOrgData, ThrowOnError>): RequestResult<GetOrgResponses, GetOrgErrors, ThrowOnError> => (options.client ?? client).get<GetOrgResponses, GetOrgErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}',
    ...options
});

export const updateOrg = <ThrowOnError extends boolean = false>(options: Options<UpdateOrgData, ThrowOnError>): RequestResult<UpdateOrgResponses, UpdateOrgErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrgResponses, UpdateOrgErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>): RequestResult<ListMembersResponses, ListMembersErrors, ThrowOnError> => (options.client ?? client).get<ListMembersResponses, ListMembersErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/members',
    ...options
});

export const removeMember = <ThrowOnError extends boolean = false>(options: Options<RemoveMemberData, ThrowOnError>): RequestResult<RemoveMemberResponses, RemoveMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveMemberResponses, RemoveMemberErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/members/{userId}',
    ...options
});

export const updateMember = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberData, ThrowOnError>): RequestResult<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/members/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listRoles = <ThrowOnError extends boolean = false>(options: Options<ListRolesData, ThrowOnError>): RequestResult<ListRolesResponses, ListRolesErrors, ThrowOnError> => (options.client ?? client).get<ListRolesResponses, ListRolesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/roles',
    ...options
});

export const listInvitations = <ThrowOnError extends boolean = false>(options: Options<ListInvitationsData, ThrowOnError>): RequestResult<ListInvitationsResponses, ListInvitationsErrors, ThrowOnError> => (options.client ?? client).get<ListInvitationsResponses, ListInvitationsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/invitations',
    ...options
});

export const createInvitation = <ThrowOnError extends boolean = false>(options: Options<CreateInvitationData, ThrowOnError>): RequestResult<CreateInvitationResponses, CreateInvitationErrors, ThrowOnError> => (options.client ?? client).post<CreateInvitationResponses, CreateInvitationErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const revokeInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokeInvitationData, ThrowOnError>): RequestResult<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError> => (options.client ?? client).delete<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/invitations/{invitationId}',
    ...options
});

export const acceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationData, ThrowOnError>): RequestResult<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError> => (options.client ?? client).post<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/invitations/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApprovalPolicy = <ThrowOnError extends boolean = false>(options: Options<GetApprovalPolicyData, ThrowOnError>): RequestResult<GetApprovalPolicyResponses, GetApprovalPolicyErrors, ThrowOnError> => (options.client ?? client).get<GetApprovalPolicyResponses, GetApprovalPolicyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/approval-policy',
    ...options
});

export const putApprovalPolicy = <ThrowOnError extends boolean = false>(options: Options<PutApprovalPolicyData, ThrowOnError>): RequestResult<PutApprovalPolicyResponses, PutApprovalPolicyErrors, ThrowOnError> => (options.client ?? client).put<PutApprovalPolicyResponses, PutApprovalPolicyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/approval-policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listActivity = <ThrowOnError extends boolean = false>(options: Options<ListActivityData, ThrowOnError>): RequestResult<ListActivityResponses, ListActivityErrors, ThrowOnError> => (options.client ?? client).get<ListActivityResponses, ListActivityErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/activity',
    ...options
});

export const listAccounts = <ThrowOnError extends boolean = false>(options: Options<ListAccountsData, ThrowOnError>): RequestResult<ListAccountsResponses, ListAccountsErrors, ThrowOnError> => (options.client ?? client).get<ListAccountsResponses, ListAccountsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/accounts',
    ...options
});

export const getAccountStatement = <ThrowOnError extends boolean = false>(options: Options<GetAccountStatementData, ThrowOnError>): RequestResult<GetAccountStatementResponses, GetAccountStatementErrors, ThrowOnError> => (options.client ?? client).get<GetAccountStatementResponses, GetAccountStatementErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/accounts/{accountId}/statement',
    ...options
});

export const listFundingInstruments = <ThrowOnError extends boolean = false>(options: Options<ListFundingInstrumentsData, ThrowOnError>): RequestResult<ListFundingInstrumentsResponses, ListFundingInstrumentsErrors, ThrowOnError> => (options.client ?? client).get<ListFundingInstrumentsResponses, ListFundingInstrumentsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/accounts/{accountId}/funding',
    ...options
});

/**
 * Sandbox only. Asks the partner's test environment to send funds to the account's virtual account.
 */
export const simulateDeposit = <ThrowOnError extends boolean = false>(options: Options<SimulateDepositData, ThrowOnError>): RequestResult<SimulateDepositResponses, SimulateDepositErrors, ThrowOnError> => (options.client ?? client).post<SimulateDepositResponses, SimulateDepositErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/accounts/{accountId}/simulate-deposit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listPayments = <ThrowOnError extends boolean = false>(options: Options<ListPaymentsData, ThrowOnError>): RequestResult<ListPaymentsResponses, ListPaymentsErrors, ThrowOnError> => (options.client ?? client).get<ListPaymentsResponses, ListPaymentsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/payments',
    ...options
});

/**
 * Sends money to a recipient. The amount plus fee is reserved immediately; payments above the approval threshold wait for approvers. Requires two-factor authentication. Retrying with the same Idempotency-Key returns the original payment.
 *
 */
export const createPayment = <ThrowOnError extends boolean = false>(options: Options<CreatePaymentData, ThrowOnError>): RequestResult<CreatePaymentResponses, CreatePaymentErrors, ThrowOnError> => (options.client ?? client).post<CreatePaymentResponses, CreatePaymentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/payments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getPayment = <ThrowOnError extends boolean = false>(options: Options<GetPaymentData, ThrowOnError>): RequestResult<GetPaymentResponses, GetPaymentErrors, ThrowOnError> => (options.client ?? client).get<GetPaymentResponses, GetPaymentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/payments/{paymentId}',
    ...options
});

export const listCounterparties = <ThrowOnError extends boolean = false>(options: Options<ListCounterpartiesData, ThrowOnError>): RequestResult<ListCounterpartiesResponses, ListCounterpartiesErrors, ThrowOnError> => (options.client ?? client).get<ListCounterpartiesResponses, ListCounterpartiesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/counterparties',
    ...options
});

/**
 * Adds a recipient with a US bank account or a wallet. Requires two-factor authentication.
 */
export const createCounterparty = <ThrowOnError extends boolean = false>(options: Options<CreateCounterpartyData, ThrowOnError>): RequestResult<CreateCounterpartyResponses, CreateCounterpartyErrors, ThrowOnError> => (options.client ?? client).post<CreateCounterpartyResponses, CreateCounterpartyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/counterparties',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const archiveCounterparty = <ThrowOnError extends boolean = false>(options: Options<ArchiveCounterpartyData, ThrowOnError>): RequestResult<ArchiveCounterpartyResponses, ArchiveCounterpartyErrors, ThrowOnError> => (options.client ?? client).delete<ArchiveCounterpartyResponses, ArchiveCounterpartyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/counterparties/{counterpartyId}',
    ...options
});

export const getCounterparty = <ThrowOnError extends boolean = false>(options: Options<GetCounterpartyData, ThrowOnError>): RequestResult<GetCounterpartyResponses, GetCounterpartyErrors, ThrowOnError> => (options.client ?? client).get<GetCounterpartyResponses, GetCounterpartyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/counterparties/{counterpartyId}',
    ...options
});

export const getPaymentLimits = <ThrowOnError extends boolean = false>(options: Options<GetPaymentLimitsData, ThrowOnError>): RequestResult<GetPaymentLimitsResponses, GetPaymentLimitsErrors, ThrowOnError> => (options.client ?? client).get<GetPaymentLimitsResponses, GetPaymentLimitsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/payment-limits',
    ...options
});

/**
 * Prices each way to send a payment (rail, fee, arrival) without moving money.
 */
export const quotePayment = <ThrowOnError extends boolean = false>(options: Options<QuotePaymentData, ThrowOnError>): RequestResult<QuotePaymentResponses, QuotePaymentErrors, ThrowOnError> => (options.client ?? client).post<QuotePaymentResponses, QuotePaymentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/payments/quote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const approvePayment = <ThrowOnError extends boolean = false>(options: Options<ApprovePaymentData, ThrowOnError>): RequestResult<ApprovePaymentResponses, ApprovePaymentErrors, ThrowOnError> => (options.client ?? client).post<ApprovePaymentResponses, ApprovePaymentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/payments/{paymentId}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const rejectPayment = <ThrowOnError extends boolean = false>(options: Options<RejectPaymentData, ThrowOnError>): RequestResult<RejectPaymentResponses, RejectPaymentErrors, ThrowOnError> => (options.client ?? client).post<RejectPaymentResponses, RejectPaymentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/payments/{paymentId}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const cancelPayment = <ThrowOnError extends boolean = false>(options: Options<CancelPaymentData, ThrowOnError>): RequestResult<CancelPaymentResponses, CancelPaymentErrors, ThrowOnError> => (options.client ?? client).post<CancelPaymentResponses, CancelPaymentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/payments/{paymentId}/cancel',
    ...options
});

export const getOnboarding = <ThrowOnError extends boolean = false>(options: Options<GetOnboardingData, ThrowOnError>): RequestResult<GetOnboardingResponses, GetOnboardingErrors, ThrowOnError> => (options.client ?? client).get<GetOnboardingResponses, GetOnboardingErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/onboarding',
    ...options
});

/**
 * Saves a draft. Masked or empty SSN/EIN values keep what was stored.
 */
export const saveOnboarding = <ThrowOnError extends boolean = false>(options: Options<SaveOnboardingData, ThrowOnError>): RequestResult<SaveOnboardingResponses, SaveOnboardingErrors, ThrowOnError> => (options.client ?? client).put<SaveOnboardingResponses, SaveOnboardingErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/onboarding',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const uploadOnboardingDocument = <ThrowOnError extends boolean = false>(options: Options<UploadOnboardingDocumentData, ThrowOnError>): RequestResult<UploadOnboardingDocumentResponses, UploadOnboardingDocumentErrors, ThrowOnError> => (options.client ?? client).post<UploadOnboardingDocumentResponses, UploadOnboardingDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/onboarding/documents',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const submitOnboardingDocuments = <ThrowOnError extends boolean = false>(options: Options<SubmitOnboardingDocumentsData, ThrowOnError>): RequestResult<SubmitOnboardingDocumentsResponses, SubmitOnboardingDocumentsErrors, ThrowOnError> => (options.client ?? client).post<SubmitOnboardingDocumentsResponses, SubmitOnboardingDocumentsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/onboarding/documents/submit',
    ...options
});

export const submitOnboarding = <ThrowOnError extends boolean = false>(options: Options<SubmitOnboardingData, ThrowOnError>): RequestResult<SubmitOnboardingResponses, SubmitOnboardingErrors, ThrowOnError> => (options.client ?? client).post<SubmitOnboardingResponses, SubmitOnboardingErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_session',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/orgs/{orgId}/onboarding/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
